export const ocplcDashboard = `query GetOcplcDashboard {
  ocplcDashboard {
    ocplcProductModels {
      kmatId
      productLineID
      productLineName
      manufacturingName
      productGroup
      status
      author
      lastModifiedTS
      toadLogicalLock
    }
    ocplcProductLines {
      id
      name
      count
    }
    statuses
  }
}`


export const releaseLock = `mutation UpdateAuthor($input: UpdateAuthorRequest!) {
  UpdateAuthor(input: $input) {
    message
  }
}
 `